import echo from "@/echo/echo";

let canal = null;
let esCanalPrivado = false;

export function suscribirACanalDeSubastas(subasta, onPujaActualizada) {
  if (!subasta?.id) return false;

  abandonarCanalDeSubastas();

  canal = `subastas.${subasta.id}.pujas`;
  esCanalPrivado = Boolean(subasta.privada);

  const channel = esCanalPrivado
    ? echo.private(canal)
    : echo.channel(canal);

    channel.subscribed(() => {})
    .error((error) => {
      console.error("Error autorizando canal privado de crédito:", error);
    })
    .listen(".PujaActualizada", (event) => {
      console.log("[creditChannel] CreditUpdated received", event);
      onPujaActualizada(event);
    });

  return true;
}

export function abandonarCanalDeSubastas() {
  if (!canal) return;

  echo.leave(canal);
  canal = null;
  esCanalPrivado = false;
}
